import React from "react";
import noAvatar from "../../assets/images/no-avatar.png";
import { useHistory } from "react-router-dom";

const Teaser = ({ trainer }) => {
  const url = (trainer && trainer.trainer.avatarUrl) || noAvatar;
  const history = useHistory();

  return (
      <div className='teaser'>
        <div
          className="teaser-avatar"
          style={{
            backgroundImage: `url(${url})`,
            borderRadius: '50%'
          }}
        >
        </div>
        <div className="teaser-trainer-name color-black">{`${trainer.trainer.firstName} ${trainer.trainer.lastName}`}</div>
        <div className="teaser-trainer-region color-black">Region: {trainer.region.name}</div>
        <div className="teaser-trainer-region color-black">Team: {trainer.region.team}</div>
        <div className='teaser-actions'>
          <button 
            onClick={() => history.push({
              pathname: '/appointment-book',
              state: { trainer }
            })}
          >
            Termin vereinbaren
          </button>
          <button
            onClick={() => history.push({
              pathname: '/trainer-message',
              state:  { trainerId: trainer.trainer.id } 
            })}
          >
            Nachricht schreiben
          </button>
      </div>
      </div>
  );
};

export default Teaser;
